import { render, staticRenderFns } from "./OzLoadingSpinner.vue?vue&type=template&id=0e972c25&scoped=true&"
import script from "./OzLoadingSpinner.vue?vue&type=script&lang=ts&"
export * from "./OzLoadingSpinner.vue?vue&type=script&lang=ts&"
import style0 from "./OzLoadingSpinner.vue?vue&type=style&index=0&id=0e972c25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e972c25",
  null
  
)

export default component.exports